module.exports = new __parcel__URL__("BrickfilmersGuild.d568c2fd.jpeg").toString();